export default __webpack_public_path__ + "static/media/MLBRapidBGSelectTeam.8a7c9d18.png";